import { render, staticRenderFns } from "./FertilizerDetails.vue?vue&type=template&id=0c36ec4e&scoped=true&"
import script from "./FertilizerDetails.vue?vue&type=script&lang=js&"
export * from "./FertilizerDetails.vue?vue&type=script&lang=js&"
import style0 from "./FertilizerDetails.vue?vue&type=style&index=0&id=0c36ec4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36ec4e",
  null
  
)

export default component.exports